export default __webpack_public_path__ + "static/media/cpf-logo.44533b0b.svg";